// @flow

import type { BasicProps, EasyAction, PropsSchema } from '../../type'
import * as React from 'react'
import computeData from '../hoc/computeData'

type Props = BasicProps & {};

@computeData({ includeVisible: false })
export default class GetGeoLocation extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      type: 'event',
      title: '成功',
      event: 'resolve'
    },
    {
      type: 'event',
      title: '失败',
      event: 'reject'
    }
  ];
  static actions: EasyAction[] = [
    {
      title: '获取经纬度',
      name: 'geolocation'
    }
  ];

  actionGeolocation = () => {
    const { callActions } = this.props
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          callActions('resolve', {
            longitude: position.coords.longitude,
            latitude: position.coords.latitude
          })
        },
        function () {
          callActions('reject')
        }
      )
    } else {
      callActions('reject')
    }
  };

  render () {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/program/GetGeoLocation.js